import axios from '../../libs/axios_csrf';
import React from 'react';

import { injectIntl } from 'react-intl';
import { inject } from 'mobx-react';
import {
  Row,
  Col,
  Table,
  Button,
  Grid,
  Collapse,
  Tab,
  Nav,
  NavItem,
  PanelGroup,
  Panel,
} from 'react-bootstrap';
import ItemsMenu from './ItemsMenu';

@inject('membersStore', 'rootStore')
@injectIntl
export default class Boards extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const { rootStore } = this.props;

    if (rootStore.modal)
      document.getElementById('igheader-tooltip-button').click();
  }

  render() {
    return (
      <div className="panel-fixed-height">
        <ItemsMenu items="bRoles" />
      </div>
    );
  }
}
